/*
* Copyright (C) Regione Lombardia
*/
import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CoreI18nConfigs } from '@core/configs/i18n.config';
import {
    AnagraficaTipologiaOpera,
    DatalistAnagrafica,
    Rilevamento
} from '@models';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OperaService } from '@shared/services/opera.service';
import { UtilsService } from '@shared/services/utils.service';
import { CurrencyMaskInputMode } from 'ngx-currency';
import {AnagraficaService} from "@shared/services/anagrafica.service";

@Component({
    selector: 'app-toolkit-opera-modal-sopralluogo',
    templateUrl: './modal-sopralluogo.component.html',
})
export class ToolkitGestioneOperaModalSopralluogoComponent implements OnInit {

    @Input() canEdit: boolean;
    @Input() azione: string;
    @Input() params: Rilevamento;
    @Input() datalist: DatalistAnagrafica;

    public criteriaForm: FormGroup;
    public tipologiaOperaFiltered: AnagraficaTipologiaOpera[] = [];
    readonly natural = CurrencyMaskInputMode.NATURAL;
    public entitaDannoLabel: string = '-';

    constructor(
        public activeModal: NgbActiveModal,
        private operaService: OperaService,
        private utilsService: UtilsService,
        private fb: FormBuilder,
        private anagraficaService: AnagraficaService,
        private cdr: ChangeDetectorRef
    ) { }

    ngOnInit() {
        this.criteriaForm = this.fb.group({
            idRilevamento: this.fb.control(null),
            idOpera: this.fb.control(this.operaService.operaSession.idOpera, Validators.required),
            idTipologia: this.fb.control(null),
            idTipoEvento: this.fb.control(null),
            idFonte: this.fb.control(null),
            rilevatore: this.fb.control(null),
            dataRilevamento: this.fb.control(null),
            efficienza: this.fb.control(null),
            efficacia: this.fb.control(null),
            dataEvento: this.fb.control(null),
            descrizioneEvento: this.fb.control(null),
            descrizioneDanno: this.fb.control(null),
            entitaDanno: this.fb.control(null),
            propostaIntervento: this.fb.control(null),
            richiestaFinanziamento: this.fb.control(null),
            note: this.fb.control(null)
        });
        if (this.params) {
            this.criteriaForm.patchValue(this.params);
        }
        if (!this.canEdit) {
            this.criteriaForm.disable();
        }
        if (this.azione === 'Visualizza') {
            const idDanno = this.criteriaForm.get('entitaDanno')?.value;
            if (idDanno) {
                this.getDescrizioneLivelloDanno(idDanno);
            }
        }
    }

    public saveSopralluogo() {
        if (this.criteriaForm.invalid) {
            this.utilsService.showError(CoreI18nConfigs.messages.fieldRequired);
            return;
        }
        this.activeModal.close(this.criteriaForm);
    }

    public getDescrizioneLivelloDanno(idDanno: string): void {
        this.anagraficaService.getDescrizioneLivelloDanno(idDanno).subscribe({
            next: (res) => {
                this.entitaDannoLabel = res.descrizione;
                this.cdr.detectChanges();
            },
            error: (err) => {
                console.error('Errore nel recupero della descrizione:', err);
                this.entitaDannoLabel = '-';
            }
        });
    }



}
